export enum statisticsTopic {
  GATHERING_DATA = 'gathering-data',
  INVESTIGATING_DATA = 'investigating-data',
  FREQUENCY_TABLES = 'frequency-tables',
  RELATIVE_AND_CUMULATIVE_FREQUENCY = 'relative-and-cumulative-frequency',
  VALIDITY = 'validity',
  RELIABILITY = 'reliability',
  REPRESENTATIVITY = 'representativity',
  SIGNIFICANCE = 'significance',
  RANDOM_VARIABLES = 'random-variables',
  OBSERVATIONS = 'observations',
  CENTRAL_TENDENCIES = 'central-tendencies',
  MODE = 'mode',
  MEDIAN = 'median',
  MEAN = 'mean',
}
